import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  Chip,
  Avatar,
  Grid,
  Switch,
  FormControlLabel,
  Alert,
  Paper,
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  CardGiftcard as GiftIcon,
  Stars as StarsIcon,
  LocalOffer as OfferIcon,
  Category as CategoryIcon,
  Refresh as RefreshIcon,
  CheckCircle as ActiveIcon,
  Cancel as InactiveIcon,
  TrendingUp as TrendingUpIcon,
  Info as InfoIcon,
  Warning as WarningIcon,
  PersonSearch as PersonSearchIcon,
  Phone as PhoneIcon,
  TableChart as TabletIcon,
  Watch as WatchIcon,
} from '@mui/icons-material';

const RewardCatorgy = () => {
  const [categories, setCategories] = useState([
    {
      id: 1,
      categoryCode: 'RWD-CAT-001',
      categoryName: 'Bike',
      description: 'Bike and motorcycle related rewards, accessories, and services',
      rewardType: 'Free Product',
      minPoints: 500,
      maxPoints: 50000,
      pointsValue: 5,
      valuePerPoint: 0.1,
      totalRewards: 45,
      activeRewards: 38,
      status: 'Active',
      displayOrder: 1,
      isPopular: true,
      createdDate: '2024-01-15',
      updatedDate: '2024-01-15',
      color: '#1976d2',
    },
    {
      id: 2,
      categoryCode: 'RWD-CAT-002',
      categoryName: 'Travel',
      description: 'Travel packages, hotel bookings, flight tickets, and vacation rewards',
      rewardType: 'Gift Voucher',
      minPoints: 1000,
      maxPoints: 100000,
      pointsValue: 10,
      valuePerPoint: 0.15,
      totalRewards: 28,
      activeRewards: 22,
      status: 'Active',
      displayOrder: 2,
      isPopular: true,
      createdDate: '2024-01-16',
      updatedDate: '2024-01-16',
      color: '#2e7d32',
    },
    {
      id: 3,
      categoryCode: 'RWD-CAT-003',
      categoryName: 'Fan',
      description: 'Loyalty fan rewards, exclusive merchandise, early access, and VIP benefits',
      rewardType: 'Special Offer',
      minPoints: 200,
      maxPoints: 20000,
      pointsValue: 2,
      valuePerPoint: 0.2,
      totalRewards: 32,
      activeRewards: 28,
      status: 'Active',
      displayOrder: 3,
      isPopular: true,
      createdDate: '2024-01-17',
      updatedDate: '2024-01-17',
      color: '#ff9800',
    },
    {
      id: 4,
      categoryCode: 'RWD-CAT-004',
      categoryName: 'Gadgets',
      description: 'Electronic gadgets, smartphones, tablets, smartwatches, and tech accessories',
      keywords: ['Electronic gadgets', 'Smartphones', 'Tablets', 'Smartwatches', 'Tech accessories', 'Electronics', 'Mobile devices', 'Wearables'],
      rewardType: 'Free Product',
      minPoints: 1000,
      maxPoints: 100000,
      pointsValue: 10,
      valuePerPoint: 0.15,
      totalRewards: 35,
      activeRewards: 28,
      status: 'Active',
      displayOrder: 4,
      isPopular: true,
      createdDate: '2024-01-18',
      updatedDate: '2024-01-18',
      color: '#9c27b0',
    },
  ]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [statusConfirmDialogOpen, setStatusConfirmDialogOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [newCategory, setNewCategory] = useState({
    categoryCode: '',
    categoryName: '',
    description: '',
    keywords: [],
    keywordInput: '',
    rewardType: '',
    minPoints: '',
    maxPoints: '',
    pointsValue: '',
    valuePerPoint: '',
    displayOrder: '',
    status: 'Active',
    isPopular: false,
  });

  const [errors, setErrors] = useState({});

  const rewardTypeOptions = [
    'Cash Discount',
    'Free Product',
    'Percentage Discount',
    'Special Offer',
    'Experience',
    'Gift Voucher',
  ];

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0);
  };

  // Mock data for associate reward redemptions
  const [associateRedemptions] = useState([
    {
      id: 1,
      associateId: 'ASSO-001',
      associateName: 'Rajesh Kumar',
      rewardId: 'RWD-004',
      rewardName: 'Samsung Galaxy S23',
      categoryName: 'Gadgets',
      categoryCode: 'RWD-CAT-004',
      keywords: ['Smartphones'],
      pointsUsed: 25000,
      redemptionDate: '2024-01-20',
      status: 'Approved',
    },
    {
      id: 2,
      associateId: 'ASSO-002',
      associateName: 'Priya Sharma',
      rewardId: 'RWD-005',
      rewardName: 'iPad Pro 12.9"',
      categoryName: 'Gadgets',
      categoryCode: 'RWD-CAT-004',
      keywords: ['Tablets'],
      pointsUsed: 45000,
      redemptionDate: '2024-01-18',
      status: 'Approved',
    },
    {
      id: 3,
      associateId: 'ASSO-003',
      associateName: 'Amit Patel',
      rewardId: 'RWD-006',
      rewardName: 'Apple Watch Series 9',
      categoryName: 'Gadgets',
      categoryCode: 'RWD-CAT-004',
      keywords: ['Smartwatches'],
      pointsUsed: 35000,
      redemptionDate: '2024-01-19',
      status: 'Approved',
    },
    {
      id: 4,
      associateId: 'ASSO-004',
      associateName: 'Sneha Reddy',
      rewardId: 'RWD-007',
      rewardName: 'iPhone 15 Pro',
      categoryName: 'Gadgets',
      categoryCode: 'RWD-CAT-004',
      keywords: ['Smartphones'],
      pointsUsed: 55000,
      redemptionDate: '2024-01-17',
      status: 'Approved',
    },
    {
      id: 5,
      associateId: 'ASSO-005',
      associateName: 'Vikram Singh',
      rewardId: 'RWD-008',
      rewardName: 'Samsung Galaxy Tab S9',
      categoryName: 'Gadgets',
      categoryCode: 'RWD-CAT-004',
      keywords: ['Tablets'],
      pointsUsed: 40000,
      redemptionDate: '2024-01-16',
      status: 'Approved',
    },
  ]);

  const [searchKeyword, setSearchKeyword] = useState('');
  const [showAssociateSearch, setShowAssociateSearch] = useState(false);

  const filteredCategories = categories.filter((cat) => {
    const matchesSearch =
      cat.categoryName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cat.categoryCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cat.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'All' || cat.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  // Filter associates by keyword (phone, tablet, smartwatch, etc.)
  const filteredAssociates = searchKeyword
    ? associateRedemptions.filter((redemption) => {
        const keywordLower = searchKeyword.toLowerCase();
        return (
          redemption.associateName.toLowerCase().includes(keywordLower) ||
          redemption.associateId.toLowerCase().includes(keywordLower) ||
          redemption.rewardName.toLowerCase().includes(keywordLower) ||
          redemption.keywords.some((kw) => kw.toLowerCase().includes(keywordLower))
        );
      })
    : [];

  // Filter associates who earned gadgets (phones, tablets, smartwatches)
  const getAssociatesByKeyword = (keyword) => {
    const keywordLower = keyword.toLowerCase();
    return associateRedemptions.filter((redemption) =>
      redemption.keywords.some((kw) => kw.toLowerCase().includes(keywordLower)) ||
      redemption.rewardName.toLowerCase().includes(keywordLower)
    );
  };

  const displayData = filteredCategories.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleView = (category) => {
    setSelectedCategory(category);
    setViewDialogOpen(true);
  };

  const handleEdit = (category) => {
    setSelectedCategory(category);
    setNewCategory({
      categoryCode: category.categoryCode,
      categoryName: category.categoryName,
      description: category.description,
      keywords: category.keywords || [],
      keywordInput: '',
      rewardType: category.rewardType,
      minPoints: category.minPoints,
      maxPoints: category.maxPoints,
      pointsValue: category.pointsValue,
      valuePerPoint: category.valuePerPoint,
      displayOrder: category.displayOrder,
      status: category.status,
      isPopular: category.isPopular,
    });
    setEditDialogOpen(true);
    setErrors({});
  };

  const handleAdd = () => {
    setNewCategory({
      categoryCode: '',
      categoryName: '',
      description: '',
      keywords: [],
      keywordInput: '',
      rewardType: '',
      minPoints: '',
      maxPoints: '',
      pointsValue: '',
      valuePerPoint: '',
      displayOrder: '',
      status: 'Active',
      isPopular: false,
    });
    setAddDialogOpen(true);
    setErrors({});
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newCategory.categoryCode.trim()) {
      newErrors.categoryCode = 'Category code is required';
    }
    if (!newCategory.categoryName.trim()) {
      newErrors.categoryName = 'Category name is required';
    }
    if (!newCategory.rewardType) {
      newErrors.rewardType = 'Reward type is required';
    }
    if (!newCategory.minPoints || newCategory.minPoints <= 0) {
      newErrors.minPoints = 'Valid minimum points is required';
    }
    if (!newCategory.maxPoints || newCategory.maxPoints <= 0) {
      newErrors.maxPoints = 'Valid maximum points is required';
    }
    if (parseInt(newCategory.maxPoints) <= parseInt(newCategory.minPoints)) {
      newErrors.maxPoints = 'Maximum points must be greater than minimum points';
    }
    if (!newCategory.pointsValue || newCategory.pointsValue <= 0) {
      newErrors.pointsValue = 'Valid points value is required';
    }
    if (!newCategory.valuePerPoint || newCategory.valuePerPoint <= 0) {
      newErrors.valuePerPoint = 'Valid value per point is required';
    }
    if (!newCategory.displayOrder || newCategory.displayOrder <= 0) {
      newErrors.displayOrder = 'Valid display order is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (!validateForm()) {
      return;
    }

    if (editDialogOpen && selectedCategory) {
      const { keywordInput, ...categoryData } = newCategory;
      const updated = categories.map((cat) =>
        cat.id === selectedCategory.id
          ? {
              ...cat,
              ...categoryData,
              updatedDate: new Date().toISOString().split('T')[0],
            }
          : cat
      );
      setCategories(updated);
      setEditDialogOpen(false);
      setSuccessMessage('Reward category updated successfully');
    } else {
      const { keywordInput, ...categoryData } = newCategory;
      const newCat = {
        id: categories.length + 1,
        ...categoryData,
        totalRewards: 0,
        activeRewards: 0,
        createdDate: new Date().toISOString().split('T')[0],
        updatedDate: new Date().toISOString().split('T')[0],
        color: ['#1976d2', '#2e7d32', '#ff9800', '#9c27b0', '#f44336', '#00acc1'][
          categories.length % 6
        ],
      };
      setCategories([...categories, newCat]);
      setAddDialogOpen(false);
      setSuccessMessage('Reward category added successfully');
    }

    setTimeout(() => setSuccessMessage(''), 3000);
    const { keywordInput, ...categoryDataWithoutInput } = newCategory;
    setNewCategory({
      categoryCode: '',
      categoryName: '',
      description: '',
      keywords: [],
      keywordInput: '',
      rewardType: '',
      minPoints: '',
      maxPoints: '',
      pointsValue: '',
      valuePerPoint: '',
      displayOrder: '',
      status: 'Active',
      isPopular: false,
    });
  };

  const handleDelete = (category) => {
    setSelectedCategory(category);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = () => {
    setCategories(categories.filter((cat) => cat.id !== selectedCategory.id));
    setDeleteDialogOpen(false);
    setSelectedCategory(null);
    setSuccessMessage('Reward category deleted successfully');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleStatusToggle = (category) => {
    setSelectedCategory(category);
    setStatusConfirmDialogOpen(true);
  };

  const confirmStatusToggle = () => {
    setCategories((prev) =>
      prev.map((item) =>
        item.id === selectedCategory.id
          ? {
              ...item,
              status: item.status === 'Active' ? 'Inactive' : 'Active',
              updatedDate: new Date().toISOString().split('T')[0],
            }
          : item
      )
    );
    setStatusConfirmDialogOpen(false);
    setSelectedCategory(null);
    setSuccessMessage(
      `Reward category ${selectedCategory.status === 'Active' ? 'deactivated' : 'activated'} successfully`
    );
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const getAvatarColor = (name) => {
    const colors = ['#1976d2', '#d32f2f', '#388e3c', '#f57c00', '#7b1fa2', '#00acc1'];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const getAvatarInitials = (name) => {
    const words = name.split(' ');
    if (words.length === 1) {
      return name.substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  // Calculate statistics
  const totalCategories = categories.length;
  const activeCategories = categories.filter((cat) => cat.status === 'Active').length;
  const totalRewards = categories.reduce((sum, cat) => sum + cat.totalRewards, 0);
  const activeRewards = categories.reduce((sum, cat) => sum + cat.activeRewards, 0);

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
              Reward Categories
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage reward categories and their configurations
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<PersonSearchIcon />}
              onClick={() => setShowAssociateSearch(true)}
              sx={{
                fontWeight: 600,
                px: 3,
                py: 1.2,
                textTransform: 'none',
                fontSize: '15px',
                borderRadius: 2,
                borderColor: '#536DFE',
                color: '#536DFE',
                '&:hover': {
                  borderColor: '#536DFE',
                  backgroundColor: '#f0f7ff',
                },
              }}
            >
              Find Associates
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleAdd}
              sx={{
                fontWeight: 600,
                px: 3,
                py: 1.2,
                textTransform: 'none',
                fontSize: '15px',
                boxShadow: '0 4px 12px rgba(83, 109, 254, 0.3)',
                borderRadius: 2,
                backgroundColor: '#536DFE',
                '&:hover': {
                  backgroundColor: '#3f51b5',
                  boxShadow: '0 6px 16px rgba(83, 109, 254, 0.4)',
                },
              }}
            >
              Add Category
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Success/Error Messages */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }} onClose={() => setSuccessMessage('')}>
          {successMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }} onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              borderLeft: '4px solid #1976d2',
              background: 'linear-gradient(135deg, #e3f2fd 0%, #f0f7ff 100%)',
              '&:hover': {
                boxShadow: '0 4px 16px rgba(25, 118, 210, 0.2)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                    Total Categories
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" sx={{ color: '#1976d2' }}>
                    {totalCategories}
                  </Typography>
                </Box>
                <CategoryIcon sx={{ fontSize: 48, color: '#1976d2', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              borderLeft: '4px solid #2e7d32',
              background: 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)',
              '&:hover': {
                boxShadow: '0 4px 16px rgba(46, 125, 50, 0.2)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                    Active Categories
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" sx={{ color: '#2e7d32' }}>
                    {activeCategories}
                  </Typography>
                </Box>
                <ActiveIcon sx={{ fontSize: 48, color: '#2e7d32', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              borderLeft: '4px solid #ff9800',
              background: 'linear-gradient(135deg, #fff3e0 0%, #fef7e0 100%)',
              '&:hover': {
                boxShadow: '0 4px 16px rgba(255, 152, 0, 0.2)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                    Total Rewards
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" sx={{ color: '#ff9800' }}>
                    {totalRewards}
                  </Typography>
                </Box>
                <GiftIcon sx={{ fontSize: 48, color: '#ff9800', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              borderLeft: '4px solid #9c27b0',
              background: 'linear-gradient(135deg, #f3e5f5 0%, #fce4ec 100%)',
              '&:hover': {
                boxShadow: '0 4px 16px rgba(156, 39, 176, 0.2)',
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                    Active Rewards
                  </Typography>
                  <Typography variant="h4" fontWeight="bold" sx={{ color: '#9c27b0' }}>
                    {activeRewards}
                  </Typography>
                </Box>
                <StarsIcon sx={{ fontSize: 48, color: '#9c27b0', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid> */}

      {/* Filters */}
      <Card sx={{ mb: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            Category Filters
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by name, code, or description..."
                value={searchTerm}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} label="Status">
                  <MenuItem value="All">All Status</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                variant="outlined"
                startIcon={<RefreshIcon />}
                onClick={() => {
                  setSearchTerm('');
                  setStatusFilter('All');
                }}
                sx={{
                  height: '40px',
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#536DFE',
                  color: '#536DFE',
                  '&:hover': {
                    borderColor: '#536DFE',
                    backgroundColor: '#f0f7ff',
                  },
                }}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Categories Table */}
      <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2, mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            Category List
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#536DFE' }}>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Category</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Points Range</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }} align="center">
                    Status
                  </TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }} align="center">
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {displayData.length > 0 ? (
                  displayData.map((cat) => (
                    <TableRow
                      key={cat.id}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' },
                        '&:hover': { backgroundColor: '#f0f7ff !important' },
                      }}
                    >
                      <TableCell>
                        <Box display="flex" alignItems="center" gap={1.5}>
                          <Avatar
                            sx={{
                              bgcolor: getAvatarColor(cat.categoryName),
                              width: 40,
                              height: 40,
                              fontSize: '0.875rem',
                              fontWeight: 700,
                            }}
                          >
                            {getAvatarInitials(cat.categoryName)}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                              {cat.categoryName}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {cat.categoryCode}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {cat.minPoints} - {cat.maxPoints}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Value: ₹{cat.valuePerPoint}/point
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <FormControlLabel
                          control={
                            <Switch
                              checked={cat.status === 'Active'}
                              onChange={() => handleStatusToggle(cat)}
                              color="success"
                              size="medium"
                            />
                          }
                          label={
                            <Chip
                              label={cat.status}
                              size="small"
                              color={cat.status === 'Active' ? 'success' : 'default'}
                              sx={{ fontWeight: 600 }}
                            />
                          }
                          sx={{ m: 0 }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box display="flex" gap={0.5} justifyContent="center">
                          <Tooltip title="View Category">
                            <IconButton
                              color="info"
                              size="small"
                              onClick={() => handleView(cat)}
                              sx={{ border: '1px solid #e0e0e0' }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Category">
                            <IconButton
                              color="primary"
                              size="small"
                              onClick={() => handleEdit(cat)}
                              sx={{ border: '1px solid #e0e0e0' }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Category">
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => handleDelete(cat)}
                              sx={{ border: '1px solid #e0e0e0' }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        No categories found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {filteredCategories.length > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Showing {page * rowsPerPage + 1} to{' '}
                {Math.min((page + 1) * rowsPerPage, filteredCategories.length)} of {filteredCategories.length}{' '}
                categories
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button
                  size="small"
                  onClick={() => setPage(Math.max(0, page - 1))}
                  disabled={page === 0}
                  sx={{ textTransform: 'none' }}
                >
                  Previous
                </Button>
                <Button
                  size="small"
                  onClick={() => setPage(Math.min(Math.ceil(filteredCategories.length / rowsPerPage) - 1, page + 1))}
                  disabled={page >= Math.ceil(filteredCategories.length / rowsPerPage) - 1}
                  sx={{ textTransform: 'none' }}
                >
                  Next
                </Button>
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Add/Edit Dialog */}
      <Dialog
        open={addDialogOpen || editDialogOpen}
        onClose={() => {
          setAddDialogOpen(false);
          setEditDialogOpen(false);
          setErrors({});
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: '#536DFE',
            color: 'white',
            py: 2.5,
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
            {editDialogOpen ? 'Edit Reward Category' : 'Add Reward Category'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category Code"
                value={newCategory.categoryCode}
                onChange={(e) => setNewCategory({ ...newCategory, categoryCode: e.target.value })}
                error={!!errors.categoryCode}
                helperText={errors.categoryCode}
                required
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Category Name"
                value={newCategory.categoryName}
                onChange={(e) => setNewCategory({ ...newCategory, categoryName: e.target.value })}
                error={!!errors.categoryName}
                helperText={errors.categoryName}
                required
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="small" error={!!errors.rewardType}>
                <InputLabel>Reward Type</InputLabel>
                <Select
                  value={newCategory.rewardType}
                  onChange={(e) => setNewCategory({ ...newCategory, rewardType: e.target.value })}
                  label="Reward Type"
                >
                  {rewardTypeOptions.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
                {errors.rewardType && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.75 }}>
                    {errors.rewardType}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Minimum Points"
                value={newCategory.minPoints}
                onChange={(e) => setNewCategory({ ...newCategory, minPoints: e.target.value })}
                error={!!errors.minPoints}
                helperText={errors.minPoints}
                required
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Maximum Points"
                value={newCategory.maxPoints}
                onChange={(e) => setNewCategory({ ...newCategory, maxPoints: e.target.value })}
                error={!!errors.maxPoints}
                helperText={errors.maxPoints}
                required
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Points Value"
                value={newCategory.pointsValue}
                onChange={(e) => setNewCategory({ ...newCategory, pointsValue: e.target.value })}
                error={!!errors.pointsValue}
                helperText={errors.pointsValue}
                required
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                step="0.01"
                label="Value Per Point (₹)"
                value={newCategory.valuePerPoint}
                onChange={(e) => setNewCategory({ ...newCategory, valuePerPoint: e.target.value })}
                error={!!errors.valuePerPoint}
                helperText={errors.valuePerPoint}
                required
                size="small"
                InputProps={{
                  startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Display Order"
                value={newCategory.displayOrder}
                onChange={(e) => setNewCategory({ ...newCategory, displayOrder: e.target.value })}
                error={!!errors.displayOrder}
                helperText={errors.displayOrder}
                required
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={newCategory.status}
                  onChange={(e) => setNewCategory({ ...newCategory, status: e.target.value })}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newCategory.isPopular}
                    onChange={(e) => setNewCategory({ ...newCategory, isPopular: e.target.checked })}
                    color="primary"
                  />
                }
                label="Mark as Popular Category"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                value={newCategory.description}
                onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                multiline
                rows={3}
                size="small"
                placeholder="Enter category description..."
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                Keywords / Tags
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
                {newCategory.keywords?.map((keyword, index) => (
                  <Chip
                    key={index}
                    label={keyword}
                    onDelete={() => {
                      const updatedKeywords = newCategory.keywords.filter((_, i) => i !== index);
                      setNewCategory({ ...newCategory, keywords: updatedKeywords });
                    }}
                    size="small"
                    sx={{ backgroundColor: '#536DFE', color: 'white' }}
                  />
                ))}
              </Box>
              <TextField
                fullWidth
                size="small"
                placeholder="Add keyword (e.g., Smartphones, Tablets, Smartwatches...)"
                value={newCategory.keywordInput}
                onChange={(e) => setNewCategory({ ...newCategory, keywordInput: e.target.value })}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && newCategory.keywordInput.trim()) {
                    e.preventDefault();
                    const keyword = newCategory.keywordInput.trim();
                    if (!newCategory.keywords.includes(keyword)) {
                      setNewCategory({
                        ...newCategory,
                        keywords: [...(newCategory.keywords || []), keyword],
                        keywordInput: '',
                      });
                    } else {
                      setNewCategory({ ...newCategory, keywordInput: '' });
                    }
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => {
                          if (newCategory.keywordInput.trim()) {
                            const keyword = newCategory.keywordInput.trim();
                            if (!newCategory.keywords.includes(keyword)) {
                              setNewCategory({
                                ...newCategory,
                                keywords: [...(newCategory.keywords || []), keyword],
                                keywordInput: '',
                              });
                            } else {
                              setNewCategory({ ...newCategory, keywordInput: '' });
                            }
                          }
                        }}
                        edge="end"
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                Press Enter or click + to add keywords (e.g., Electronic gadgets, Smartphones, Tablets, etc.)
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: '#f8f9fa' }}>
          <Button
            onClick={() => {
              setAddDialogOpen(false);
              setEditDialogOpen(false);
              setErrors({});
            }}
            variant="outlined"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1,
              fontWeight: 600,
              borderRadius: 1.5,
              backgroundColor: '#536DFE',
              '&:hover': {
                backgroundColor: '#3f51b5',
              },
            }}
          >
            {editDialogOpen ? 'Update' : 'Add'} Category
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Dialog */}
      <Dialog
        open={viewDialogOpen}
        onClose={() => setViewDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: '#536DFE',
            color: 'white',
            py: 2.5,
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
            Category Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          {selectedCategory && (
            <Grid container spacing={2}>
              <Grid item xs={12} display="flex" justifyContent="center" mb={2}>
                <Avatar
                  sx={{
                    bgcolor: getAvatarColor(selectedCategory.categoryName),
                    width: 100,
                    height: 100,
                    fontSize: '2.5rem',
                    fontWeight: 700,
                  }}
                >
                  {getAvatarInitials(selectedCategory.categoryName)}
                </Avatar>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Category Code
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.categoryCode}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Category Name
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.categoryName}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Reward Type
                </Typography>
                <Chip
                  label={selectedCategory.rewardType}
                  size="small"
                  sx={{
                    backgroundColor: selectedCategory.color,
                    color: 'white',
                    fontWeight: 600,
                    mt: 0.5,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Status
                </Typography>
                <Chip
                  label={selectedCategory.status}
                  size="small"
                  color={selectedCategory.status === 'Active' ? 'success' : 'default'}
                  sx={{ fontWeight: 600, mt: 0.5 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Points Range
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.minPoints} - {selectedCategory.maxPoints}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Value Per Point
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  ₹{selectedCategory.valuePerPoint}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Total Rewards
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.totalRewards} ({selectedCategory.activeRewards} Active)
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Display Order
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.displayOrder}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Description
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.description}
                </Typography>
              </Grid>
              {selectedCategory.keywords && selectedCategory.keywords.length > 0 && (
                <Grid item xs={12}>
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, mb: 1, display: 'block' }}>
                    Keywords / Tags
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {selectedCategory.keywords.map((keyword, index) => (
                      <Chip
                        key={index}
                        label={keyword}
                        size="small"
                        sx={{ backgroundColor: selectedCategory.color, color: 'white', fontWeight: 600 }}
                      />
                    ))}
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Created Date
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.createdDate}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Updated Date
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                  {selectedCategory.updatedDate}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: '#f8f9fa' }}>
          <Button onClick={() => setViewDialogOpen(false)} variant="outlined" sx={{ textTransform: 'none', fontWeight: 600 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: '#536DFE',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 3,
            px: 3,
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
            Delete Reward Category
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to delete the category <strong>"{selectedCategory?.categoryName}"</strong>?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This action cannot be undone. All associated rewards will also be affected.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2, borderTop: '1px solid #e0e0e0', bgcolor: '#f8f9fa' }}>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            variant="outlined"
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1,
              fontWeight: 600,
              borderRadius: 1.5,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDelete}
            variant="contained"
            color="error"
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1,
              fontWeight: 600,
              borderRadius: 1.5,
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Status Toggle Confirmation Dialog */}
      <Dialog
        open={statusConfirmDialogOpen}
        onClose={() => setStatusConfirmDialogOpen(false)}
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: '#536DFE',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 3,
            px: 3,
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
            {selectedCategory?.status === 'Active' ? 'Deactivate Category' : 'Activate Category'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to {selectedCategory?.status === 'Active' ? 'deactivate' : 'activate'} the category{' '}
            <strong>"{selectedCategory?.categoryName}"</strong>?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {selectedCategory?.status === 'Active'
              ? 'Deactivating this category will make it unavailable for new rewards.'
              : 'Activating this category will make it available for new rewards.'}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2, borderTop: '1px solid #e0e0e0', bgcolor: '#f8f9fa' }}>
          <Button
            onClick={() => setStatusConfirmDialogOpen(false)}
            variant="outlined"
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1,
              fontWeight: 600,
              borderRadius: 1.5,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={confirmStatusToggle}
            variant="contained"
            color={selectedCategory?.status === 'Active' ? 'warning' : 'success'}
            startIcon={selectedCategory?.status === 'Active' ? <InactiveIcon /> : <ActiveIcon />}
            sx={{
              textTransform: 'none',
              px: 3,
              py: 1,
              fontWeight: 600,
              borderRadius: 1.5,
            }}
          >
            {selectedCategory?.status === 'Active' ? 'Deactivate' : 'Activate'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Find Associates Dialog */}
      <Dialog
        open={showAssociateSearch}
        onClose={() => {
          setShowAssociateSearch(false);
          setSearchKeyword('');
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: '#536DFE',
            color: 'white',
            py: 2.5,
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
            Find Associates by Reward Keywords
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3, pt: 3 }}>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Search for associates who earned rewards like phones, tablets, smartwatches, etc.
            </Typography>
            <TextField
              fullWidth
              placeholder="Search by keyword (e.g., phone, tablet, smartwatch, smartphone)..."
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
              <Chip
                label="Phone / Smartphone"
                onClick={() => setSearchKeyword('phone')}
                icon={<PhoneIcon />}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: searchKeyword.toLowerCase() === 'phone' ? '#536DFE' : 'default',
                  color: searchKeyword.toLowerCase() === 'phone' ? 'white' : 'default',
                }}
              />
              <Chip
                label="Tablet"
                onClick={() => setSearchKeyword('tablet')}
                icon={<TabletIcon />}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: searchKeyword.toLowerCase() === 'tablet' ? '#536DFE' : 'default',
                  color: searchKeyword.toLowerCase() === 'tablet' ? 'white' : 'default',
                }}
              />
              <Chip
                label="Smartwatch"
                onClick={() => setSearchKeyword('smartwatch')}
                icon={<WatchIcon />}
                sx={{
                  cursor: 'pointer',
                  backgroundColor: searchKeyword.toLowerCase() === 'smartwatch' ? '#536DFE' : 'default',
                  color: searchKeyword.toLowerCase() === 'smartwatch' ? 'white' : 'default',
                }}
              />
            </Box>
          </Box>

          {filteredAssociates.length > 0 ? (
            <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#536DFE' }}>
                    <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Associate</TableCell>
                    <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Reward</TableCell>
                    <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Keywords</TableCell>
                    <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Points Used</TableCell>
                    <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Date</TableCell>
                    <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredAssociates.map((redemption) => (
                    <TableRow
                      key={redemption.id}
                      hover
                      sx={{
                        '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' },
                        '&:hover': { backgroundColor: '#f0f7ff !important' },
                      }}
                    >
                      <TableCell>
                        <Box display="flex" alignItems="center" gap={1.5}>
                          <Avatar
                            sx={{
                              bgcolor: getAvatarColor(redemption.associateName),
                              width: 36,
                              height: 36,
                              fontSize: '0.875rem',
                              fontWeight: 700,
                            }}
                          >
                            {getAvatarInitials(redemption.associateName)}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '14px' }}>
                              {redemption.associateName}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {redemption.associateId}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {redemption.rewardName}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {redemption.rewardId}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                          {redemption.keywords.map((keyword, idx) => (
                            <Chip
                              key={idx}
                              label={keyword}
                              size="small"
                              sx={{
                                backgroundColor: '#9c27b0',
                                color: 'white',
                                fontWeight: 600,
                                fontSize: '0.7rem',
                              }}
                            />
                          ))}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#9c27b0' }}>
                          {redemption.pointsUsed.toLocaleString()}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          {redemption.redemptionDate}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={redemption.status}
                          size="small"
                          color={redemption.status === 'Approved' ? 'success' : 'default'}
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : searchKeyword ? (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" color="text.secondary">
                No associates found for "{searchKeyword}"
              </Typography>
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Enter a keyword above to search (e.g., phone, tablet, smartwatch)
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: '#f8f9fa' }}>
          <Button
            onClick={() => {
              setShowAssociateSearch(false);
              setSearchKeyword('');
            }}
            variant="outlined"
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default RewardCatorgy;

